<template>
    <UiCard v-if="inquiry && inquiry.id" interactive class="ui-card--preview" @click="open">
        <div class="ui-card__id">
            {{ inquiry.id }}
        </div>
        <div class="ui-card__body py-2">
            <div v-if="inquiry.type" class="ui-card__primary">
                {{ inquiry.type }}
            </div>
            <div v-if="inquiry.name">
                {{ inquiry.name }}
            </div>
            <div v-if="inquiry.email">
                {{ inquiry.email }}
            </div>
            <div v-if="inquiry.phone">
                {{ inquiry.phone }}
            </div>
            <div class="ui-card__muted">
                {{ dateHumanReadable(inquiry.created_at) }}
            </div>
        </div>
        <div class="ui-card__summary">
            <div v-if="!inquiry.is_spam">
                <ul
                    v-if="inquiry.receivers && inquiry.receivers.length > 0"
                    class="px-4 py-2 font-mono text-xs border rounded shadow-sm bg-neutral-100 border-neutral-300 dark:bg-neutral-900 dark:border-neutral-800 text-left"
                >
                    <li class="ui-card__primary">
                        {{ lang('inquiries::inquiries.fields.receivers') }}
                    </li>
                    <li v-for="receiver in inquiry.receivers" :key="receiver">
                        {{ receiver.email }}
                    </li>
                </ul>
            </div>
        </div>
    </UiCard>
</template>

<script setup lang="ts">
import { toRef } from 'vue';
import { Inquiry } from '@src/Inquiries/Pages/types';
import { dateHumanReadable } from '@src/Common/Helpers/dates';
import { router } from '@inertiajs/vue3';

const props = defineProps<{
    inquiry: Inquiry;
}>();

const inquiry = toRef(props, 'inquiry');

const open = (): void => {
    router.visit(route('inquiries.admin.show', { id: inquiry.value.id }));
};
</script>
